import httpClient from "../client/httpClient";
import generateAvatarImage from "./generateAvatarImage";

const parseUrl = (url) => {
    if (!url) return null;
    const [base, ...paths] = url.split("/");
    const encodedPaths = paths.map((segment) => encodeURIComponent(segment));
    return [base, ...encodedPaths].join("/");
};

export default async function getCustomerData(customerId) {
    const customerDataRes = await httpClient.get(`v1/api/customer/customer-profile/${customerId}`);
    const { id, firstName, lastName, profileImgPath } = customerDataRes.data;

    const customer = {
        id: id,
        name: firstName + " " + lastName
    };

    const avatarImage = generateAvatarImage(customer.name);

    return {
        ...customer,
        image: !profileImgPath ? avatarImage : parseUrl(profileImgPath)
    };
}
